import React, { useEffect, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const TicketsLabelSelect = ({ selectedLabels = [], onChange }) => {
	const [labels, setLabels] = useState([]);

	const fetchLabels = async () => {
		try {
			const { data } = await api.get("/tickets/labels");
			setLabels(data);
		} catch (err) {
			toastError(err);
		}
	};

	useEffect(() => {
		void fetchLabels();
	}, []);

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<div style={{ width: 120, marginTop: -4 }}>
			<FormControl fullWidth margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={selectedLabels}
					onChange={handleChange}
					onOpen={fetchLabels}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={() =>
						selectedLabels.length > 0
							? `${i18n.t("ticketsLabelSelect.placeholder")} (${selectedLabels.length})`
							: i18n.t("ticketsLabelSelect.placeholder")
					}
				>
					{labels.map(label => (
						<MenuItem dense key={label.name} value={label.name}>
							<Checkbox
								style={{ color: label.color }}
								size="small"
								color="primary"
								checked={selectedLabels.indexOf(label.name) > -1}
							/>
							<ListItemText primary={label.name} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsLabelSelect;
